// Admin UserDetailPage — /app/admin/users/:id, the one detail route. Fetches the user once and hands it
// to the page for their role.
import { Link, useParams } from "react-router-dom";
import { useFetch } from "../../hooks/useApi.js";
import StudentDetailPage from "./StudentDetailPage.js";
import TutorDetailPage from "./TutorDetailPage.js";
import AdminDetailPage from "./AdminDetailPage.js";
import { IconArrowLeft } from "../../components/shared/icons.js";
import type { AdminUserRecord } from "@dm-lms/shared/types";

export default function UserDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = useFetch<AdminUserRecord>(id ? `/api/users/${id}` : null);
  // useFetch keeps the previous user while the next one loads; never show the wrong person.
  const user = data && data.id === id ? data : null;

  const backTo = user && user.role !== "admin" ? `/app/admin/users?role=${user.role}` : "/app/admin/users";

  return (
    <div className="dm-page">
      <Link to={backTo} className="mb-4 inline-flex items-center gap-1.5 text-sm text-dm-blue hover:underline">
        <IconArrowLeft width={14} height={14} />
        All users
      </Link>

      {isLoading && !user && <p className="text-dm-slate text-sm">Loading user…</p>}
      {error && <p className="text-red-600 text-sm">{error}</p>}

      {user?.role === "student" && <StudentDetailPage student={user} />}
      {user?.role === "tutor" && <TutorDetailPage user={user} />}
      {user?.role === "admin" && <AdminDetailPage user={user} />}
    </div>
  );
}
